<div class="container">
  <div class="bg-white header">
    <div class="border-bottom row mx-0 p-3">
      <div class="col-12 col-sm-6 d-flex align-items-center pt-2">
        <h4>
          {{ "Sellers.Dashboard.BalanceInfo" | translate }}
        </h4>
      </div>
    </div>
  </div>
  <div class="bg-white header">
    <div class="border-bottom row mx-0 px-3">
      <div class="col-12 col-sm-6 d-flex align-items-center pt-1">
        <h6>
          {{ "Sellers.Products.AddWithdrawalRequest" | translate }}
        </h6>
      </div>
    </div>
  </div>
  <div id="withdrawalBalance" class="row mx-0">
    <div class="col-12 col-md-5">
      <div id="balanceInfoGraphic" class="d-flex flex-column">
        <div id="pendingBalance" class="d-flex justify-content-between px-3">
          <p>{{ balanceObject?.pendingBalance }}</p>
          <p class="d-flex flex-column">
            <span
              ><img
                src="../../../../../../assets//icons//pending-balance.svg" /></span
            >{{ "Sellers.Dashboard.PendingBalance" | translate }}
          </p>
        </div>
        <div id="availableBalance" class="d-flex justify-content-between px-3">
          <p>{{ balanceObject?.avalibleBalance }}</p>
          <p class="d-flex flex-column">
            <span>
              <img
                src="../../../../../../assets//icons//available-balance.svg"
              /> </span
            >{{ "Sellers.Dashboard.AvailableBalance" | translate }}
          </p>
        </div>
        <div *ngIf="availableFeesPercentage" class="align-center px-0">
              <button class="btn btn-success w-100" (click)="convertPendingToAvailableFees()">
                {{ 'Sellers.Products.ConvertBalance' | translate }}
              </button>
      </div>
    </div>
    </div>
    <div id="Withdrawal-request" class="bg-white col-12 col-md-7 pt-3 pb-1">
      <form *ngIf="withdrawForm" #f="ngForm" [formGroup]="withdrawForm">
        <div class="row mx-0 align-items-center">
          <div class="col-md-6 mb-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label
                >{{ "Sellers.Products.AccountOrWalletNumber" | translate }}:</mat-label
              >
              <mat-select
                class="select-input"
                style="height: 46px; margin-top: -20px"
                formControlName="account_number"
                [disabled]="isDisabled"
              >
                <mat-option selected disabled value="null"
                  >{{ "Sellers.Products.AccountOrWalletNumber" | translate }}
                </mat-option>
                <mat-option
                  *ngFor="let account of accounts"
                  [value]="account.id"
                  >{{ account.account_number }}
                </mat-option>
              </mat-select>
              <mat-error
                class="text-danger"
                *ngIf="formValidator?.formErrors?.account_number"
              >
                {{ formValidator.formErrors.account_number }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-6 mb-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{
                "Sellers.Products.EnterAmountEGP" | translate
              }}</mat-label>
              <input
                type="number"
                formControlName="required_amount"
                matInput
                required
                #rm
              />
              <mat-error
                class="text-danger"
                *ngIf="formValidator?.formErrors?.required_amount"
              >
                {{ formValidator.formErrors.required_amount }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-6 mb-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label
                >{{ "Sellers.Products.WithdrawalType" | translate }}::</mat-label
              >
              <mat-select
                class="select-input"
                style="height: 46px; margin-top: -20px"
                formControlName="withdrwal_type"
                [disabled]="isDisabled"
              >
                <mat-option selected disabled value="null"
                  >{{ "Sellers.Products.SelectWithdrawalType" | translate }}
                </mat-option>
                <mat-option [value]="'NORMAL'">{{
                  "Sellers.Products.Normal" | translate
                }}</mat-option>
                <mat-option [value]="'URGENT'">{{
                  "Sellers.Products.Urgent" | translate
                }}</mat-option>
              </mat-select>
              <mat-error
                class="text-danger"
                *ngIf="formValidator?.formErrors?.withdrwal_type"
              >
                {{ formValidator.formErrors.withdrwal_type }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-6 mb-3">
            <button
              class="btn btn-success w-100"
              style="margin-top: -10px"
              type="submit"
              id="submit"
              value="Submit"
              (click)="onSubmit()"
              [disabled]="withdrawForm.invalid"
            >
              {{ "Sellers.Products.Submit" | translate }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="bg-white header">
    <div class="border-bottom row mx-0 px-3">
      <div class="col-12 col-sm-6 d-flex align-items-center pt-1">
        <h6>
          {{ "Sellers.Products.RecurringWithdrawalRequest" | translate }}
        </h6>
      </div>
    </div>
  </div>
  <div id="recurringBalance" class="row mx-0">
    <div class="col-12 col-md-5">
      <div class="graphicSquare">
        <p>
          <span>
            <img
              src="../../../../../../assets//icons//arrow-right-circle.svg"
            />
          </span>
          <span>{{ "Sellers.Products.RecurringMsg1" | translate }}</span>
        </p>
        <p>
          <span>
            <img
              src="../../../../../../assets//icons//arrow-right-circle.svg"
            />
          </span>
          <span>{{ "Sellers.Products.RecurringMsg2" | translate }}</span>
        </p>
        <p>
          <span>
            <img
              src="../../../../../../assets//icons//arrow-right-circle.svg"
            />
          </span>
          <span>{{ "Sellers.Products.RecurringMsg3" | translate }}</span>
        </p>
      </div>
    </div>
    <div class="bg-white col-12 col-md-7 pt-3 pb-1">
      <form
        *ngIf="withdrawForm"
        #f="ngForm"
        [formGroup]="recurringWithdrawForm"
      >
        <div class="row mx-0 align-items-center">
          <div class="col-md-6 mb-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label
                >{{ "Sellers.Products.AccountOrWalletNumber" | translate }}:</mat-label
              >
              <mat-select
                class="select-input"
                style="height: 46px; margin-top: -20px"
                formControlName="account_number"
                [disabled]="isRecurringActive"
              >
                <mat-option selected disabled value="null"
                  >{{ "Sellers.Products.AccountOrWalletNumber" | translate }}
                </mat-option>
                <mat-option
                  *ngFor="let account of accounts"
                  [value]="account.id"
                  >{{ account.account_number }}
                </mat-option>
              </mat-select>
              <mat-error
                class="text-danger"
                *ngIf="formValidator?.formErrors?.account_number"
              >
                {{ formValidator.formErrors.account_number }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-6 mb-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label
                >{{
                  "Sellers.Products.SelectRecurringDay" | translate
                }}:</mat-label
              >
              <mat-select
                class="select-input"
                style="height: 46px; margin-top: -20px"
                formControlName="recurring_day"
                [disabled]="isRecurringActive"
              >
                <mat-option selected disabled value="null"
                  >{{ "Sellers.Products.SelectRecurringDay" | translate }}
                </mat-option>
                <mat-option [value]="'RecurringSundays'"
                  >{{ "Sellers.Products.RecurringSundays" | translate }}
                </mat-option>
                <mat-option [value]="'RecurringWednesDays'"
                  >{{ "Sellers.Products.RecurringWednesDays" | translate }}
                </mat-option>
                <mat-option [value]="'RecurringBoth'"
                  >{{ "Sellers.Products.RecurringBoth" | translate }}
                </mat-option>
              </mat-select>
              <mat-error
                class="text-danger"
                *ngIf="formValidator?.formErrors?.recurring_day"
              >
                {{ formValidator.formErrors.recurring_day }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <button
              *ngIf="!isRecurringActive"
              class="btn btn-primary"
              type="submit"
              id="recurringSubmit"
              value="recurringSubmit"
              (click)="onRecurringSubmit()"
              [disabled]="recurringWithdrawForm.invalid || isRecurringActive"
            >
              {{ "Sellers.Products.Subscribe" | translate }}
            </button>
            <button
              *ngIf="isRecurringActive"
              class="btn btn-secondary w-100"
              type="submit"
              id="cancelRecurringSubmit"
              value="cancelRecurringSubmit"
              (click)="onRecurringCancel()"
            >
              {{ "Sellers.Products.UnSubscribe" | translate }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="bg-white header">
    <div class="border-bottom row mx-0 px-3">
      <div class="col-12 col-sm-6 d-flex align-items-center pt-1">
        <h6>
          {{ reportName }}
        </h6>
      </div>
    </div>
  </div>
</div>
<!-- Withdrawals Report -->
<div class="card mt-4 px-3">
  <app-base-report
    [hasCheckboxes]="false"
    [showReportName]="false"
    [reportName]="reportName"
    [defaultColumns]="displayedColumns"
    [columnsDisplayNames]="displayTableColumns"
    [data]="withdrwalReportData"
    [rowsLength]="totalNumberOfRecords"
    (filterTrigger)="filter($event)"
    [tableLoading]="loading"
    [hasSort]="true"
    (sortTrigger)="sortChange($event)"
    [serviceInstance]="withdrawalsReportService"
    (paginationChange)="paginate($event)"
    (searchChange)="searchChange($event)"
  ></app-base-report>
</div>
